import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';
import {
  Account,
  Attachment,
  Post,
} from '@jaimo-solutions-gmbh/platform-services-module';
import { openConsent, openShare } from '../../../helpers';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { getImagePath } from '../../utils/getImagePath';
import { isBlacklisted } from 'src/app/utils/blacklist';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mobile-fullscreen',
  templateUrl: './mobile-fullscreen.component.html',
  styleUrls: ['./mobile-fullscreen.component.scss'],
})
export class MobileFullscreenComponent implements OnInit {
  @ViewChild('postContent') postContent: ElementRef;

  closeIcon = faClose;
  post: Post;
  attachments: Attachment[];
  index;
  height;
  contentHeight;
  isExpanded;

  prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

  constructor(
    navParams: NavParams,
    private router: Router,
    private modalCtrl: ModalController
  ) {
    this.post = navParams.get('post');
    this.index = navParams.get('index');
    this.attachments = this.getAttachments();
  }

  ngOnInit() {}

  ngAfterViewInit() {}

  getAttachments() {
    if (!this.post.cover) return this.post.attachments;
    return [this.post.cover.image, ...this.post.attachments];
  }

  openShare = (post) => openShare(post, this.modalCtrl);

  openConsent = async (url, source) => {
    await this.modalCtrl.dismiss();

    if (!isBlacklisted(url)) {
      openConsent(url, undefined, this.modalCtrl);
    } else {
      openConsent(url, source, this.modalCtrl);
    }
  };

  goToStage = ({ handle }: Account) => {
    this.router.navigate[`/${handle}`];
  };

  isDesktop() {
    return window.innerWidth >= 992;
  }

  getImageURL(fileName) {
    return getImagePath() + fileName;
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
